import styled from 'styled-components';
import { PageType } from '../../../types/Page';
import { NoonReportStatusEnum, NoonReportTypeEnum } from '../../../types/ViewModel/AolEnums';
import theme from 'src/theme';

type StyledProps = {
    isSelected?: boolean;
    noonReportType?: NoonReportTypeEnum;
    noonReportStatus?: NoonReportStatusEnum;
    isValid?: boolean;
    page?: PageType;
};

export const Wrapper = styled.div<StyledProps>`
    height: calc(100% - 5px);
    .aol-list-header {
        font-size: 0.8rem;
        font-weight: 500;
        background: ${theme.legacyColors.headingPanelBgColor};
        padding: 0;
        color: ${theme.legacyColors.headingColor};
        border-bottom: 2px solid ${theme.legacyColors.headingColor};
        height: 60px;

        &.filter-header {
            padding: 0;
        }

        &.button-header {
            padding: 0;
        }
    }

    .aol-list-tabs {
        font-size: 0.8rem;
        font-weight: 500;
        background: #fff;
        padding: 0;
        color: #2e4004;
        margin: 2px;
        .tab {
            margin: 1px;
            flex: 0 0 32.4%;
            box-shadow: none;
        }
    }

    .aol-list {
        overflow: auto;
        height: calc(100vh - ${theme.constants.pageHeaderHeight} - 130px);
    }
`;

export const TabsWrapper = styled.div`
    display: flex;
    flex: 0 1 auto;
    margin: 0 0 0 5px;
    align-self: end;
`;

export const TabListButton = styled.div<StyledProps>`
    font-weight: 600;
    font-size: 0.75rem;
    padding: 15px 10px;
    border: 1px solid #ddd;
    height: 50px;
    border-radius: 3px;
    transition: background-color 50ms cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    ${(props) => props.theme.selectableElement(props.isSelected)}
    &.full-width {
        flex: 0 0 50%;
        text-align: center;
    }

    .warning-icon {
        position: absolute;
        right: 0;
        top: 0;
    }
`;

export const AolListItemWrapper = styled.div`
    .aol-item {
        margin-top: 2px;
    }
`;

export const AolListItem = styled.div<StyledProps>`
    box-shadow: 0 5px 5px -3px #ddd;
    border-bottom: 1px solid #ddd;
    padding: 4px;
    cursor: pointer;
    color: #04265a;
    font-weight: 500;
    font-size: 0.9rem;
    ${(props) => props.theme.selectableElement(props.isSelected)}
    ${(props) => props.theme.noonReportTypeListMarker(props.noonReportType, props.isValid)}
  position: relative;
    .upper-wrapper {
        height: 20px;
        display: grid;
        grid-template-columns: 80px 1fr 50px;
        align-items: center;
        justify-items: flex-start;
        .missing-icon {
            color: red;
        }
        .icons-wrapper {
            position: absolute;
            top: 50%;
            right: 10px;
        }
        .icon-wrapper {
            margin-left: 4px;
            width: 16px;
        }
    }
    .lower-wrapper {
        display: grid;
        grid-template-columns: 60% 15% 1fr;
        height: 15px;
        align-items: start;
        font-size: 0.7rem;
        justify-content: flex-start;
        span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
`;
